/* prettier-ignore */

import { Injectable, signal } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, catchError, map, of, throwError } from "rxjs";
import { CiceroneData, Device } from "../interfaces/myCustomRoute.interface";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})

export class RestService {
  ttlTwoHours: number = 1000 * 3600 * 2; //2horas
  apiUrlBase: string = environment.apiUrlBase;
  
  ciceroneData: CiceroneData;
  device: Device;
  subDomain?: any;
  expiredLicense = signal(false);
  token: any;

  constructor(
    public http: HttpClient, 
    private router: Router) 
  {}

  setDevice(res) {
    this.device = {
      distributorID: res?.distributorID,
      type: res?.type ?? "app",
      channel: res?.channelID,
      client: res?.clientID,
      logo: res?.appStyle?.logo,
      languages: res?.lang?.availableLanguages,
      mainLanguage: res?.lang?.mainLanguage,
      headerLangType: res?.lang?.styleLanguage ?? 'flags',
      location: {
        latitude: parseFloat(res?.location?.lat),
        longitude: parseFloat(res?.location?.lng),
        address: res?.location?.address,
        searchRadius: Number(res?.location?.searchRadius) ?? 0.5
      },
      style: {
        colorCorp1: res?.appStyle?.corpColor1,
        colorCorp2: res?.appStyle?.corpColor2,
        corpCompl: res?.appStyle?.corpCompl,
        headerColor: res?.appStyle?.headerColor,
        backgroundColor: res?.appStyle?.backgroundColor,
      },
      appID: res?.appId,
      privacyPolicy: res?.privacyPolicy,
      // passport: res?.passport 
      hasIncidentsSurvey: res?.hasIncidentsSurvey // TODO: AGREGAR A SSR
    };
  }

  //--------------------------------------------------------------------------------------------------------------------------------------------------
  //------------------------------------------------------------ INCREMENTO CLICKS -------------------------------------------------------------------
  increaseVisitsPoint(id): Observable<any> {
    return this.http.post(`${this.apiUrlBase}/api/increase-point-views/${id}`, {}).pipe(
      catchError((err) => {
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  increaseVisitsEvent(id): Observable<any> {
    return this.http.post(`${this.apiUrlBase}/api/increase-event-views/${id}`, {}).pipe(
      catchError((err) => {
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }
  
  increaseVisitsHiking(id): Observable<any> {
    return this.http.post(`${this.apiUrlBase}/api/increase-hiking-views/${id}`, {}).pipe(
      catchError((err) => { 
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  increaseVisitsPdf(id): Observable<any> {
    return this.http.post(`${this.apiUrlBase}/api/increase-pdf-views/${id}`, {}).pipe(
      catchError((err) => {
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------
  //------------------------------------------------------------ API PWA ENDPOINTS -------------------------------------------------------------------

  disableRecommendedRoute(id): Observable<any> {
    return this.http.get(`${this.apiUrlBase}/api/change-route-status/${id}`).pipe(
      catchError((err) => {
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  getHomeData(): Observable<any> {
    return this.http.get(`${this.apiUrlBase}/api/get-home-app-data/${this.subDomain}`).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response);
        this.addThumbnail(response);
        return response;
      })
    );
  }

  getDetailsPoint(id: string): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-point-app-details/${id}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response);
        return response;
      })
    );
  }

  getDetailsEvent(id: string): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-event-app-details/${id}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response);
        return response;
      })
    );
  }

  getListPoints(id: string): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-categories-app-list/${id}/${this.subDomain}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        // return throwError(() => err);
        return throwError(() => new Error('getListPoints HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response?.items);
        this.addThumbnail(response?.items);
        return response;
      })
    );
  }

  getListEvents(): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-events-list/${this.subDomain}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response?.items);
        this.addThumbnail(response?.items);
        return response;
      })
    );
  }
  
  // TODO: MOCKING UNTIL BACKEND IS READY
  getListHikings(): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-hiking-list/${this.subDomain}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response?.items); 
        this.addThumbnail(response?.items);
        return response;
      })
    );
    
    //return of({
    //  filter: { 
    //    filterOptions: {
    //      accesibilities: [ 
    //        {
    //          id: 1,
    //          description: {
    //            es: "Apto para personas con movilidad reducida",
    //            fr: "Adapté aux personnes à mobilité réduite",
    //            en: "Suitable for people with reduced mobility",
    //            eu: "Mugikortasun murriztua duten pertsonentzat egokia"
    //          }
    //        },
    //        {
    //          id: 2,
    //          description: {
    //            es: "Apto para personas con discapacidad visual",
    //            fr: "Adapté aux personnes malvoyantes",
    //            en: "Suitable for visually impaired people",
    //            eu: "Ikusmen urritasuna duten pertsonentzat egokia" 
    //          },
    //        }
    //      ],
    //      tags: {
    //        singleTags: [
    //          {
    //            id: 16968,
    //            name: {
    //              es: "Aventura",
    //              fr: "Aventure",
    //              en: "Adventure",
    //              eu: "Abentura"
    //            },
    //          },
    //          {
    //            id: 17129,
    //            name: {
    //              es: "Cultural", 
    //              fr: "Culturel",
    //              en: "Cultural",
    //              eu: "Kulturala"
    //            },  
    //          }
    //        ],
    //        groups: []
    //      },
    //    },
    //    sortBy: [
    //      {
    //        "id": 0,
    //        "name": {
    //            "es": "Duración",
    //            "en": "Duration",
    //            "va": "Duración"
    //        },
    //        "type": "duration",
    //        "altName": "Duración"
    //      },
    //      {
    //        "id": 1,
    //        "name": {
    //            "es": "Popularidad",
    //            "en": "popularity",
    //            "va": "Popularitat"
    //        },
    //        "type": "popularity",
    //        "altName": "Popularidad"
    //      }
    //    ]
    //  },
    //  items: [
    //    {
    //      "id": 1,
    //      "type": "hiking",
    //      "name": {
    //          "es": "Experiencia entre viñedos de montaña: Sed de Aventura",
    //          "fr": "Expérience parmi les vignobles de montagne : Soif d'Aventure",
    //          "en": "Mountain Vineyard Experience: Thirst for Adventure",
    //          "eu": "Mendiko mahastietan esperientzia: Abentura Egarri"
    //      },
    //      "image": "https://experimental.ciceroneweb.com/storage/clients/271/interest_points/43351/image/1760703958269_72.webp",
    //      "duration": 120,
    //      "durationc": "2h.",
    //      "num_clicks": 0,
    //      "coordinates": "42.5238112,-1.5614289",
    //      "nameSlug": {
    //          "es": "experiencia-entre-vinedos-de-montana-sed-de-aventura",
    //          "fr": "experience-parmi-les-vignobles-de-montagne-soif-daventure",
    //          "en": "mountain-vineyard-experience-thirst-for-adventure",
    //          "eu": "mendiko-mahastietan-esperientzia-abentura-egarri"
    //      },
    //      "accesibilities": [1, 2],
    //      "popularity": 0,
    //      "tags": [
    //          "16968"
    //      ],
    //    },
    //    {
    //      "id": 1,
    //      "type": "hiking",
    //      "name": { 
    //          "es": "Ruta de los Castillos y Fortalezas del Valle del Ebro",
    //          "fr": "Route des Châteaux et Forteresses de la Vallée de l'Èbre",
    //          "en": "Route of the Castles and Fortresses of the Ebro Valley",
    //          "eu": "Ebro haraneko gaztelu eta gotorlekuen ibilbidea"
    //      },
    //      "image": "https://experimental.ciceroneweb.com/storage/clients/271/interest_points/43382/image/1760955367594_90-w350.webp",
    //      "duration": 240,
    //      "durationc": "4h.",
    //      "num_clicks": 0,
    //      "coordinates": "42.5238112,-1.5614289",
    //      "nameSlug": {
    //          "es": "ruta-de-los-castillos-y-fortalezas-del-valle-del-ebro",
    //          "fr": "route-des-chateaux-et-forteresses-de-la-vallee-de-lebre",  
    //          "en": "route-of-the-castles-and-fortresses-of-the-ebro-valley",
    //          "eu": "ebro-haraneko-gaztelu-eta-gotorlekuen-ibilbidea"
    //      },
    //      "accesibilities": [1],
    //      "popularity": 0,
    //      "tags": [
    //          "17129"
    //      ],
    //    }
    //  ]
    //})
  }

  getListOffers(): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-offers-list/${this.subDomain}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response?.items);
        this.addThumbnail(response?.items);
        return response;
      })
    );
  }

  getCommonApp(token = null): Observable<any> {
    let url = `${this.apiUrlBase}/api/get-common-app/${this.subDomain}`;
    if (token)
      url = `${this.apiUrlBase}/api/get-common-app/${this.subDomain}/${token}`;

    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  getItemsSearchEngineHomeApp(): Observable<any> {
    return this.http.get(`${this.apiUrlBase}/api/get-items-search-engine-home-app/${this.subDomain}`).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  getFavourites(): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-favourites-app/${this.subDomain}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  deleteAcount(user_id): any {
    return this.http.post(`${this.apiUrlBase}/api/delete-user-login`, { user_id }).pipe(
      catchError((err) => {
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  getRoute(id): any {
    return this.http.post(`${this.apiUrlBase}/api/get-route-app/${id}`, {}).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  getSurvey(id): any {
    return this.http.post(`${this.apiUrlBase}/api/get-cicerone-survey-pwa/${id}`, {}).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  saveSurvey(data): any {
    return this.http.post(`${this.apiUrlBase}/api/pwa-save-survey`, { data }).pipe(
      catchError((err) => {
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  sendStats(sesh: any) {
    return this.http.post(`${this.apiUrlBase}/api/send-stats`, { sesh }).pipe(
      catchError((err) => {
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  handleNotFound(err) {
    if (this.router.url.includes('survey-id'))
      return;

    if (err.status === 401)
      this.expiredLicense.set(true);

    if (err.status === 404 || err.status === 500 || err.status === 401) {
      this.router.navigateByUrl("not-found");
    }
  }

  getDistributorHome() {
    return this.http.get(`${this.apiUrlBase}/api/get-home-community-data/${this.subDomain}`).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response.data.homePoints);
        this.addThumbnail(response.data.homePoints);
        this.replaceUrls(response.data.appList);
        this.addThumbnail(response.data.appList);
        this.replaceUrls(response.data.heroSection);
        this.addThumbnail(response.data.heroSection);
        let events = response.data?.homePoints?.find(e => e.type === 'events')?.items;
        if (events) events = this.shuffleArray(events)
        return response;
      }),
    )
  }

  getDistributorCategoriesList(id: string): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-categories-community-app-list/${id}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response?.items);
        this.addThumbnail(response?.items);
        return response;
      })
    );
  }

  getDistributorListEvents(): Observable<any> {
    const url = `${this.apiUrlBase}/api/get-list-events/${this.subDomain}`;
    return this.http.get(url).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      }),
      map((response: any) => {
        this.replaceUrls(response?.items);
        this.addThumbnail(response?.items);
        return response;
      })
    );
  }

  getRouteDistributor(id): any {
    return this.http.post(`${this.apiUrlBase}/api/get-route-community/${id}`, {}).pipe(
      catchError((err) => {
        this.handleNotFound(err);
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    );
  }

  getAudioFromApi(body: { region: string; phrase: string; file?: boolean }) {
    return this.http.post('https://node.ciceroneweb.com/text-to-speech', body, {
      responseType: 'blob'
    });
  }

  //----------------------------------------------------------------------------------------------------------------------------------------------------------
  //-------------------- AUX FUNCTIONS -----------------------------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------------------------------------------------------------
  replaceUrls(object: any) {
    return;
    for (const key in object) {
      if (typeof object[key] === "string") {
        object[key] = this.replaceUrlLocal(object[key]);
        object[key] = this.replaceUrl(object[key]);
      } else if (typeof object[key] === "object") {
        this.replaceUrls(object[key]);
      }
    }
  }

  addThumbnail(object: any, size = "w350") {
    for (const key in object) {
      if (typeof object[key] === "string") {
        if (key == "image" || key == "cover_image") {
          const fileNameExtension = this.splitFilename(object?.image ?? object?.cover_image);
          object.imageFallback = object?.image ?? object?.cover_image ?? "/assets/imgs/imageDefault.png";
          object.image = fileNameExtension ? `${fileNameExtension.name}-${size}.${fileNameExtension.extension}` : object.imageFallback;
        }
      } else if (typeof object[key] === "object") {
        this.addThumbnail(object[key], size);
      }
    }
  }

  replaceUrl(valor: string): string {
    return valor.replace("https://experimental.ciceroneweb.com/storage/", "https://cicerone.cms-iurban.com/storage/");
  }

  replaceUrlLocal(valor: string): string {
    return valor.replace("http://cicerone-back.test/storage/", "https://cicerone.cms-iurban.com/storage/");
  }

  splitFilename(filename) {
    const dotPosition = filename?.lastIndexOf(".");
    if (!dotPosition || dotPosition === -1 || dotPosition === 0) 
      return null;

    const name = filename.substring(0, dotPosition);
    const extension = filename.substring(dotPosition + 1);
    return { name, extension };
  }

  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
  
}